var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5837 29.1663V27.708M31.5837 35.7288V34.2705M31.5837 42.2913V40.833M24.5837 23.333H44.417C46.0505 23.333 46.8672 23.333 47.4911 23.6509C48.0399 23.9305 48.4861 24.3767 48.7658 24.9255C49.0837 25.5494 49.0837 26.3662 49.0837 27.9997V29.8955C46.2647 29.8955 43.9795 32.1807 43.9795 34.9997C43.9795 37.8186 46.2647 40.1038 49.0837 40.1038V41.9997C49.0837 43.6332 49.0837 44.4499 48.7658 45.0738C48.4861 45.6226 48.0399 46.0688 47.4911 46.3484C46.8672 46.6663 46.0505 46.6663 44.417 46.6663H24.5837C22.9502 46.6663 22.1334 46.6663 21.5095 46.3484C20.9607 46.0688 20.5145 45.6226 20.2349 45.0738C19.917 44.4499 19.917 43.6332 19.917 41.9997V40.1038C22.7359 40.1038 25.0212 37.8186 25.0212 34.9997C25.0212 32.1807 22.7359 29.8955 19.917 29.8955V27.9997C19.917 26.3662 19.917 25.5494 20.2349 24.9255C20.5145 24.3767 20.9607 23.9305 21.5095 23.6509C22.1334 23.333 22.9502 23.333 24.5837 23.333Z",
    stroke: "#18C935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.0b3fba78722813556a590ffcf49a54fe.svg";
export { ForwardRef as ReactComponent };